import React from 'react';
export const UpdateBadge: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button onClick={onClick} style={{ position:'fixed', right:16, bottom:80, padding:'6px 10px', borderRadius:999, boxShadow:'0 6px 20px rgba(0,0,0,.2)', background:'#fde047', color:'#111', border:0 }}>
    Aggiorna app
  </button>
);
